import { type ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '@mp/graphql/generated';
import useGraphQLRequest from './useGraphQLRequest';

const AvailableJobForPoolJobButtonGql = graphql(`
  query GetAvailableJobForPoolJobButton($id: Int!) {
    availableJob(id: $id) {
      id
      can_book_job
    }
  }
`);

type AvailableJobForPoolJobButtonResult = ResultOf<typeof AvailableJobForPoolJobButtonGql>;

export const useVerifyJobAvailable = () => {
  const { request } = useGraphQLRequest<AvailableJobForPoolJobButtonResult>();

  const verifyJobAvailable = async (jobId: number): Promise<boolean> => {
    try {
      const data = await request(AvailableJobForPoolJobButtonGql, { id: jobId });
      return Boolean(data?.availableJob);
    } catch {
      return true;
    }
  };

  const verifyJobCanBook = async (jobId: number): Promise<boolean> => {
    try {
      const data = await request(AvailableJobForPoolJobButtonGql, { id: jobId });
      return Boolean(data?.availableJob?.can_book_job);
    } catch {
      return false;
    }
  };

  return { verifyJobAvailable, verifyJobCanBook };
};

export default useVerifyJobAvailable;
